import React, { Component } from "react";
import { connect } from "react-redux";
import PaymentModal from "./payments-modal";
import { showTip } from "../../actions/shows";
import { withRouter } from "react-router";
import { centsToMillicents } from "../../lib/money";
import { hideModal } from "../../actions/modal";
import { getShowUUID } from "../../lib/getShowUUID";

class TipModal extends Component {
  submitTip = async options => {
    let args = {
      amount: centsToMillicents(options.amount),
      showUUID: this.getShowUUID(),
    };
    if (this.props.user) {
      args = {
        ...args,
        email: this.props.user.email,
        stripeToken: options.cardID,
      };
    } else {
      args = {
        ...args,
        email: options.email,
        stripeToken: options.token.id,
      };
    }
    let resp = await this.props.showTip(args);
    if (resp.status !== 200) {
      return;
    }

    this.props.hideModal();
  };
  getShowUUID = () => getShowUUID(this.props);
  render() {
    const options = [
      {
        type: "fixedPrice",
        optionKey: "4.99",
        amount: 499,
      },
      { type: "custom", optionKey: "custom" },
    ];
    const amount = options[0].amount;
    return (
      <PaymentModal
        {...this.props}
        newCardOnly
        amount={amount}
        submit={this.submitTip}
        page1Options={options}
        mode={"tip"}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    publicShows: state.publicShows,
    user: state.user.user,
  };
}

export default connect(mapStateToProps, {
  hideModal,
  showTip,
})(withRouter(TipModal));
